import React from 'react';
import { Field, FieldSet } from '../../components/Form';
import type { DocumentType } from '../../graphql/generated/gql';
import { gql } from '../../graphql/generated/gql';
import type { IntegrationPlatformInfo } from '../../integrations/IntegrationPlatformInfo';

const INTEGRATION_FRAGMENT = gql(`
  fragment ProfilesTab_integration on Integration {
    id
    settings {
      enableEnrich
    }
  }
`);

interface ProfilesTabProps {
  platformInfo: IntegrationPlatformInfo;
}

const ProfilesTab = ({ platformInfo }: ProfilesTabProps) => {
  return (
    <FieldSet>
      <Field
        name="enableEnrich"
        type="checkbox"
        label={`Enable ${platformInfo.name} profile sync on sign-up`}
      />
    </FieldSet>
  );
};

ProfilesTab.getFormValues = ({
  settings,
}: DocumentType<typeof INTEGRATION_FRAGMENT>) => ({
  enableEnrich: settings?.enableEnrich || false,
});
ProfilesTab.getNewSettings = (
  values: ReturnType<typeof ProfilesTab.getFormValues>,
) => ({ enableEnrich: values.enableEnrich });

export default ProfilesTab;
